import { cn } from "@/lib/utils";

/**
 * Standard page header. Replaces the repeated heading + subheading +
 * inline marginBottom pattern across Dashboard, Classes, Usage, Billing, etc.
 *
 * Usage:
 *   <PageHeader title="My Classes" />
 *   <PageHeader title="My Classes" subtitle="Manage your report groups and students." />
 *   <PageHeader
 *     title="My Classes"
 *     subtitle="Manage your report groups."
 *     action={<Button onClick={...}>+ New Class</Button>}
 *   />
 */
function PageHeader({ title, subtitle, action, className }) {
  return (
    <div className={cn("mb-8", className)}>
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="font-display text-4xl font-normal text-foreground leading-tight">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-1.5 text-sm font-sans text-muted-foreground leading-normal">
              {subtitle}
            </p>
          )}
        </div>
        {action && (
          <div className="shrink-0 pt-1">{action}</div>
        )}
      </div>
    </div>
  );
}

export { PageHeader };
